import '../Assests/css/views/profile.css';
import JsonCard from '../Components/JsonCard';
import ExploringCard from '../Components/ExploringCard';
export default function Profile() {
    return (
        <section id="about" className="profile">
            <h1>HELLO. I AM <span style={{color: '#64ffda'}}>JOHN</span></h1>
            
            <div className="divider">
                <JsonCard />
            </div>
            <p className='profile-description'>I’m an IT student passionate about backend systems, AI, and algorithmic trading. I enjoy designing scalable architectures and continuously refining my engineering discipline through TDD and system design.</p>
               <div className="explorer-card">
                <ExploringCard />
            </div>
            <div className='philosophy-card'>
                <h2 className='title-head'>Engineering Philosophy</h2>
                <p className='introduction'>I believe in building systems, not just scripts—thinking in architecture rather than isolated features. I strive to design solutions that are scalable from the start, prioritizing long-term structure over short-term convenience. Above all, I value discipline over motivation, relying on consistent execution rather than fleeting inspiration.</p>
            </div>


            </section>
    );
}
